// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === "7888") return "css/design_system-341c3fa9ccfa0083.css";
if (chunkId === "1692") return "css/1692-c4fb6e03132e1a07.css";
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {"1458": "91c2d0582a97d99d","2429": "a73d2fa285645c40","5054": "badb3e695158ebb7",}[chunkId] + ".css"
}